import React from 'react';

import { Typography, Divider } from '@mui/material';

import { CommonStyles } from '@kamernet/styles/CommonStyles';
import { groupByKey } from '@kamernet/utilities/Array/groupByKey';

import { ListingsSearchContext } from '@kamernet/views/ListingsSearch/ListingsSearchContext';

import { GridGenerator } from './GridGenerator';

export const NearbyListings = () => {
  const { nearbyListings } = ListingsSearchContext.useContext();
  const nearbyListingsByCity = groupByKey(nearbyListings, 'city');

  return (
    <div>
      {nearbyListingsByCity && (
        <React.Fragment>
          {Object.entries(nearbyListingsByCity).map(
            ([city, cityListings], index) => (
              <React.Fragment key={city}>
                <Typography
                  variant="h5"
                  className={CommonStyles.padding_block_1}
                >
                  {city}
                </Typography>
                <GridGenerator listings={cityListings} />
                {/* Do not show divider after last city */}
                {index !== Object.entries(nearbyListingsByCity).length - 1 && (
                  <Divider className={CommonStyles.margin_bottom_3} />
                )}
              </React.Fragment>
            ),
          )}
        </React.Fragment>
      )}
    </div>
  );
};
